import React from 'react';
import { Unlock, Package, Play, MapPin, Infinity, Euro } from 'lucide-react';
import { advantages } from '../data/mock';

const iconMap = {
  Unlock,
  Package,
  Play,
  MapPin,
  Infinity,
  Euro
};

const AdvantagesSection = () => {
  return (
    <section id="advantages" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-[#9aae00] font-semibold text-sm uppercase tracking-wider mb-4">
            Pourquoi nous choisir
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            Les avantages Phocea Rent
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Une solution pensée pour vous simplifier l'accès aux écrans LED professionnels.
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => {
            const Icon = iconMap[advantage.icon];
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 group hover:-translate-y-1 border border-transparent hover:border-[#DFFF00]/30"
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-[#DFFF00]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#DFFF00] transition-colors duration-300">
                  <Icon className="w-7 h-7 text-[#9aae00] group-hover:text-black transition-colors duration-300" />
                </div>
                
                {/* Content */}
                <h3 className="text-xl font-bold text-slate-900 mb-3">{advantage.title}</h3>
                <p className="text-slate-600 leading-relaxed">{advantage.description}</p>
              </div>
            );
          })}
        </div>

        {/* Comparison Box */}
        <div className="mt-16 bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-slate-100">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center">
            Comparez les solutions
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            {/* Acheter */}
            <div className="bg-slate-50 rounded-2xl p-6 border-2 border-slate-200">
              <div className="text-center mb-4">
                <span className="inline-block bg-slate-200 text-slate-600 text-sm font-semibold px-3 py-1 rounded-full">
                  Acheter
                </span>
              </div>
              <ul className="space-y-3 text-sm text-slate-600">
                <li className="flex items-center gap-2">
                  <span className="w-5 h-5 bg-red-100 rounded-full flex items-center justify-center text-red-500 text-xs">✗</span>
                  Investissement > 15 000 €
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-5 h-5 bg-red-100 rounded-full flex items-center justify-center text-red-500 text-xs">✗</span>
                  Matériel à stocker
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-5 h-5 bg-red-100 rounded-full flex items-center justify-center text-red-500 text-xs">✗</span>
                  Maintenance à gérer
                </li>
              </ul>
            </div>

            {/* Financer */}
            <div className="bg-slate-50 rounded-2xl p-6 border-2 border-slate-200">
              <div className="text-center mb-4">
                <span className="inline-block bg-slate-200 text-slate-600 text-sm font-semibold px-3 py-1 rounded-full">
                  Financer
                </span>
              </div>
              <ul className="space-y-3 text-sm text-slate-600">
                <li className="flex items-center gap-2">
                  <span className="w-5 h-5 bg-red-100 rounded-full flex items-center justify-center text-red-500 text-xs">✗</span>
                  Engagement 36-48 mois
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-5 h-5 bg-red-100 rounded-full flex items-center justify-center text-red-500 text-xs">✗</span>
                  Rigidité contractuelle
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-5 h-5 bg-red-100 rounded-full flex items-center justify-center text-red-500 text-xs">✗</span>
                  Coût total élevé
                </li>
              </ul>
            </div>

            {/* Phocea Rent */}
            <div className="bg-[#DFFF00]/10 rounded-2xl p-6 border-2 border-[#DFFF00] relative">
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                <span className="bg-[#DFFF00] text-black text-xs font-bold px-3 py-1 rounded-full">
                  RECOMMANDÉ
                </span>
              </div>
              <div className="text-center mb-4">
                <span className="inline-block bg-[#DFFF00] text-black text-sm font-semibold px-3 py-1 rounded-full">
                  Phocea Rent
                </span>
              </div>
              <ul className="space-y-3 text-sm text-slate-700">
                <li className="flex items-center gap-2">
                  <span className="w-5 h-5 bg-[#DFFF00]/50 rounded-full flex items-center justify-center text-black text-xs">✓</span>
                  1 mois minimum
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-5 h-5 bg-[#DFFF00]/50 rounded-full flex items-center justify-center text-black text-xs">✓</span>
                  Flexibilité totale
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-5 h-5 bg-[#DFFF00]/50 rounded-full flex items-center justify-center text-black text-xs">✓</span>
                  Tout inclus
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
